import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Spinner from '../../Spinner';
import left from '../../../assets/icons/left.png';
import { AgCharts } from 'ag-charts-react';
import { CellTower } from "@phosphor-icons/react";

export default function RAWSPopUp({ panel , user, setPanel}) {
  const [history, setHistory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [graphData, setGraphData] = useState(null);

  const convertTimestampToHourString = (timestamp) => {
    const date = new Date(timestamp);

    const month = date.toLocaleString('default', { month: 'short' }); // e.g., "Jan", "Feb"
    const day = date.getDate();

    let hours = date.getHours();
    const minutes = date.getMinutes();

    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 hour to 12

    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${month} ${day}, ${hours}:${formattedMinutes} ${ampm}`;
  };

  const extractNumberFromString = (str) => {
    const match = str.match(/(\d+(\.\d+)?)/);
    
    if (match) {
      return parseFloat(match[0]);
    }

  
    return NaN;
  }

  const removeDuplicateTimestamps = (data) => {
    const uniqueData = {};
    const now = new Date().getTime();
    const oneDayAgo = now - 24 * 60 * 60 * 1000; // Last 24 hours in milliseconds

    data.forEach((item) => {
        const timestamp = item.observeddate;

        // Only include data within the last 24 hours
        if (timestamp >= oneDayAgo && timestamp <= now) {
            if (!uniqueData[timestamp] || uniqueData[timestamp].row_id < item.row_id) {
                uniqueData[timestamp] = item;
            }
        }
    });

    return Object.values(uniqueData);
  }

  useEffect(() => {
        axios.get(`https://firewatch-api.space-eyes.com/weather/raws/${panel.content.id}`, {
            headers: {
                'Authorization': `Bearer ${user.idToken.jwtToken}`
            }
        }).then((response) => {
            console.log(response.data.history);
            setLoading(false);
            setHistory(response.data.history);
        }).catch((err) => console.log('error getting individual raws data:', err));
  }, []);
   
  useEffect(() => {
    if (history) {
        const filteredData = history;

        setGraphData([
            {
                title: 'Wind Speed (mph)',
                series: [
                    {
                        type: "line",
                        xKey: "day",
                        xName: "Date",
                        yKey: 'windSpeed',
                        yName: 'Wind Speed',
                        interpolation: { type: "smooth" },
                    },
                ],
                data: filteredData.map((s) => {
                    return {
                        day: convertTimestampToHourString(s.observeddate),
                        windSpeed: (s.windspeedmph && s.windspeedmph !== 'NO DATA') ? extractNumberFromString(s.windspeedmph) : 0,
                    };
                }),
            },
            {
                title: 'Air Temperature (°F)',
                series: [
                    {
                        type: "line",
                        xKey: "day",
                        xName: "Date",
                        yKey: 'airTemp',
                        yName: 'Air Temperature',
                        interpolation: { type: "smooth" },
                        stroke: 'orange',
                        marker: {
                            enabled: true,
                            fill: 'orange',
                            stroke: 'red',
                            size: 5,
                        },
                    },
                ],
                data: filteredData.map((s) => {
                    return {
                        day: convertTimestampToHourString(s.observeddate),
                        airTemp: (s.airtempstandplace && s.airtempstandplace !== 'NO DATA') ? extractNumberFromString(s.airtempstandplace) : 0,
                    };
                }),
            },
            // Add similar logic for other graphs (Fuel Temperature, Solar Radiation, etc.)
        ]);
    }
  }, [history]);


  return (
    panel.content ?
    <div className='raws-page'>
      <div className='raws-page-title'>
        {/* <CellTower size={24} className='raws-page-title-icon'/> */}
        <div className='raws-page-title-text'>RAWS - {panel.content.stationname}</div>
      </div>
      <div className='raws-page-description'>RAWS (Remote Automated Weather Stations) weather data provides real-time environmental information primarily used for fire weather monitoring and management.</div>
      <div className='raws-page-subtitles'>
        <div className='raws-page-subtitles-subtitle'>
          <div className='raws-page-subtitles-subtitle-title'>County:</div>
          <div className='raws-page-subtitles-subtitle-value'>{panel.content.county ? panel.content.county : 'N/A'}</div>
        </div>
        <div className='raws-page-subtitles-subtitle'>
          <div className='raws-page-subtitles-subtitle-title'>State:</div>
          <div className='raws-page-subtitles-subtitle-value'>{panel.content.state ? panel.content.state : 'N/A'}</div>
        </div>
      </div>
      {loading ?
      <Spinner />
      :
      history ?
      <div className='raws-page-charts'>
        <div className='raws-page-back-btn' onClick={() => setPanel({name: 'RAWS', content: null})}>
            <img src={left} className='raws-page-back-btn-icon'/>
            Back to results
        </div>
        {graphData && graphData.map((graph) => {
          return (
            <AgCharts 
              options={{
                  title: {
                    text: graph.title,
                    fontStyle: "oblique",
                    fontSize: 16,
                    fontFamily: "Arial, sans-serif",
                    color: "black"
                  },
                  subtitle: {
                      text: `${panel.content.county}, ${panel.content.state}`,
                      fontStyle: "normal",
                      fontSize: 13,
                      fontFamily: "Arial, sans-serif",
                      color: "black"
                  },
                  axes: [
                      {
                        type: 'category',
                        position: 'bottom',
                        label: {
                          color: 'black',
                        }
                      },
                      {
                        type: 'number',
                        position: 'left',
                        title: {
                          text: graph.title,
                          color: 'black'
                        },
                        label: {
                          color: 'black'
                        }
                      }
                    ],
                    legend: {
                      item: {
                        label: {
                          color: 'black'
                        }
                      }
                  },
                  data: graph.data,
                  series: graph.series,
                  background: {
                      fill: "rgba(217, 217, 217, 0)",
                  },
              }}
          />
          )
        })}
      </div>
      :
      <div style={{ fontSize: '0.9rem', fontWeight: 'bold', color: 'white', paddingTop: '0.5rem' }}>Trouble retrieving RAWS data. Please try again.</div>
      }
    </div>
    :
    <></>
  )
}